module.exports = __webpack_public_path__ + "assets/img/2605.9131dd7e.png";